import { useEffect } from 'react';
import { useUIStore } from '@/state/uiStore';

const COMPOSER_FOCUS_EVENT = 'rcmc:focus-chat-composer';

export function dispatchFocusChatComposer(): void {
  window.dispatchEvent(new CustomEvent(COMPOSER_FOCUS_EVENT));
}

export function onFocusChatComposer(handler: () => void): () => void {
  window.addEventListener(COMPOSER_FOCUS_EVENT, handler);
  return () => window.removeEventListener(COMPOSER_FOCUS_EVENT, handler);
}

function isModifier(e: KeyboardEvent): boolean {
  return e.ctrlKey || e.metaKey;
}

function isTypingTarget(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  const tag = target.tagName;
  return tag === 'INPUT' || tag === 'TEXTAREA' || target.isContentEditable;
}

export function useGlobalKeyboardShortcuts(): void {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape' || e.key === 'Esc') return;

      if (!isModifier(e)) return;

      const key = e.key.toLowerCase();

      if (key === 'b') {
        e.preventDefault();
        useUIStore.getState().toggleSidebar();
        return;
      }
      if (key === 'j') {
        e.preventDefault();
        useUIStore.getState().toggleChat();
        return;
      }
      if (key === 'k' && !isTypingTarget(e.target)) {
        e.preventDefault();
        const chatOpen = useUIStore.getState().chatOpen;
        if (!chatOpen) useUIStore.getState().setChatOpen(true);
        // give the panel a tick to mount its textarea before focusing
        setTimeout(dispatchFocusChatComposer, 60);
        return;
      }
      if (key === 'k' && isTypingTarget(e.target)) {
        // already typing — Ctrl/Cmd+K still focuses the chat composer
        e.preventDefault();
        useUIStore.getState().setChatOpen(true);
        setTimeout(dispatchFocusChatComposer, 60);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);
}
